<template>
  <div>
    <h2>{{$gettext(title)}}</h2>
    <slot name="pre-data"></slot>
    <p v-if="entity.id && !this.omitDefault.includes('id')"><translate>ID</translate>: <span class="date">{{ entity.id }}</span>
    </p>
    <p v-if="entity.id_remote && !this.omitDefault.includes('id_remote')"><translate>Vlastní ID</translate>: <span class="date">{{ entity.id_remote }}</span>
    </p>
    <p v-if="entity.code && !this.omitDefault.includes('code')"><translate>Kód</translate>: <span class="date">{{ entity.code }}</span>
    </p>
    <p v-if="entity.date_created && !this.omitDefault.includes('date_created')"><translate>Založeno</translate>: <span class="date" v-html="$_date_formatFull(entity.date_created)"></span>
    </p>
    <p v-if="entity.date_updated && !this.omitDefault.includes('date_updated')"><translate>Upraveno</translate>: <span class="date" v-html="$_date_formatFull(entity.date_updated)"></span>
    </p>
    <p v-if="entity.user_created && !this.omitDefault.includes('user_created')"><translate>Vytvořil</translate>: <span class="date">{{ entity.user_created }}</span>
    </p>
    <p v-if="entity.user_updated && !this.omitDefault.includes('user_updated')"><translate>Upravil</translate>: <span class="date">{{ entity.user_updated }}</span>
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DetailEntityInfo",
  props:{
    entity: Object,
    omitDefault: {
      type: Array,
      default: ()=>[],
    },
    title: {
      type: String,
      default: 'Základní údaje'
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/DetailEntityInfo.vue